import { render, staticRenderFns } from "./exchangeVipCard.vue?vue&type=template&id=79e400b6&scoped=true&"
import script from "./exchangeVipCard.vue?vue&type=script&lang=js&"
export * from "./exchangeVipCard.vue?vue&type=script&lang=js&"
import style0 from "./exchangeVipCard.vue?vue&type=style&index=0&id=79e400b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e400b6",
  null
  
)

export default component.exports